import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import {setInventorySorting} from 'store/slice/ManufSlice';

export default function InventoryListTableHeader(){
  const dispatch = useDispatch();
  const {sorting} = useSelector((state) => state.manufslice.inventoryDashboard);
  
  const handleColumnClick = (column) => {
  const currentSorting = sorting.column === column ? !sorting.asc : true;
    dispatch(setInventorySorting({ column, asc: currentSorting }));     
  }
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>
          <Grid item lg={4} xs={6} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('productname')}> Product Name </Typography></Grid>
          <Grid item lg={4} xs={4} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('itemcount')}> Balance </Typography></Grid>

      </Grid>
      
    )
}